module.exports = "<ng-content select=\"ic-card-header\"></ng-content>\n<ng-content select=\"ic-card-filter\"></ng-content>\n<div class=\"ic-card__body\">\n    <ng-content select=\"ic-card-menu\"></ng-content>\n    <ng-content select=\"ic-card-content\"></ng-content>\n</div>\n<ng-content select=\"ic-card-footer\"></ng-content>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/card/card.component.html
// module id = ../../../../../src/app/layout/card/card.component.html
// module chunks = 3